// extracted by mini-css-extract-plugin
export default {"desk":"Navigation-module__[local]___Ob4Wf"};